/**
 * Integration logos / metadata
 * ============================
 * Iter-349 Part 12 (Frontend Perf) — extracted from `ConnectedSourcesStrip.jsx`
 * to keep the parent under the 400 LOC ratchet baseline.
 *
 * Pure data — no React. Consumed by the strip's `IntegrationLogo`
 * sub-component to render brand-coloured logos in tooltips.
 */
export const INTEGRATION_META = {
  xero: {
    name: 'Xero',
    logo: 'https://www.google.com/s2/favicons?sz=64&domain=xero.com',
    type: 'accounting',
    color: '#13B5EA',
  },
  myob: {
    name: 'MYOB',
    logo: 'https://www.google.com/s2/favicons?sz=64&domain=myob.com',
    type: 'accounting',
    color: '#6B21A8',
  },
  quickbooks: {
    name: 'QuickBooks',
    logo: 'https://www.google.com/s2/favicons?sz=64&domain=quickbooks.intuit.com',
    type: 'accounting',
    color: '#2CA01C',
  },
  square: {
    name: 'Square',
    logo: 'https://www.google.com/s2/favicons?sz=64&domain=squareup.com',
    type: 'pos',
    color: '#000000',
  },
  stripe: {
    name: 'Stripe',
    logo: 'https://www.google.com/s2/favicons?sz=64&domain=stripe.com',
    type: 'payments',
    color: '#635BFF',
  },
  tanda: {
    name: 'Tanda',
    logo: 'https://www.google.com/s2/favicons?sz=64&domain=tanda.co',
    type: 'workforce',
    color: '#FF6B35',
  },
  deputy: {
    name: 'Deputy',
    logo: 'https://www.google.com/s2/favicons?sz=64&domain=deputy.com',
    type: 'workforce',
    color: '#0052CC',
  },
  hubspot: {
    name: 'HubSpot',
    logo: 'https://www.google.com/s2/favicons?sz=64&domain=hubspot.com',
    type: 'crm',
    color: '#FF7A59',
  },
  cliniko: {
    name: 'Cliniko',
    logo: 'https://www.google.com/s2/favicons?sz=64&domain=cliniko.com',
    type: 'healthcare',
    color: '#4A90A4',
  },
  google_analytics: {
    name: 'Google Analytics',
    logo: 'https://www.google.com/s2/favicons?sz=64&domain=analytics.google.com',
    type: 'analytics',
    color: '#E37400',
  },
};
